

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { PaydayAdvanceSetup } from "../../components/PaydayAdvanceSetup/PaydayAdvanceSetup";


export const PaydayAdvancePage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="PaydayAdvance"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Payday Advance", navigateTo: "/payday-advance" }
      ]}
      mainContents={<PaydayAdvanceSetup />}
    />
  );
};
